import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Fade } from '@material-ui/core/';

const Root = styled.div`
	.loading {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 300px;

		&::before {
			content: '';
			width: 50px;
			height: 50px;
			border: 5px solid white;
			border-radius: 50%;
			animation: pulse 1s infinite;
		}
	}

	@keyframes pulse {
		0% {
			opacity: 0;
			transform: scale(0.1, 0.1);
		}
		50% {
			opacity: 1;
		}
		100% {
			opacity: 0;
			transform: scale(1.2, 1.2);
		}
	}
`;

const LoadingIndicator = () => {
	const [fadeIn, setFadeIn] = useState(false);

	useEffect(() => {
		setTimeout(() => {
			setFadeIn(true);
		}, 0);
	}, [fadeIn]);

	return (
		<Root>
			<Fade in={fadeIn} timeout={2000}>
				<div className="loading" />
			</Fade>
		</Root>
	);
};

export default LoadingIndicator;
